/* @flow */
// typecheck: ignore file
import React from 'react';

import './styles/BoxSelect.scss';

/*
 * Used in conjunction with a Box to add a button.
 */
class BoxSelect extends React.Component {
  props: {
    title?: string | React$Element<*>,
    children?: any,
  };

  render() {
    return (
      <div className="BoxSelect">
        {this.props.title &&
          <h3 className="BoxSelect-title">
            {this.props.title}
          </h3>
        }
        <div className="BoxSelect-items">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default BoxSelect;



// WEBPACK FOOTER //
// ./src/components/BoxSelect.jsx